module.exports = __webpack_public_path__ + "static/img/18.af05a2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/18.png
// module id = KXhb
// module chunks = 0